module.exports = __webpack_public_path__ + "b960f6620fdbb85c6760628ed2069c81.jpg";


//////////////////
// WEBPACK FOOTER
// ./js/img/BRCA-Exchange-fat.jpg
// module id = 1334
// module chunks = 0